<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
    <router-view id="uvod" :key="$route.path"></router-view>
    <DictionaryAbstract/>
    <SideMenu/>

    <DevInfoBlock v-if="(this.$store.state.develop || this.$store.state.isAdmin) && this.$store.state.showDevInfo"/>

    <InfoBlock v-if="msgExist"/>
</template>

<script>

import SideMenu from "@/components/menu/SideMenu.vue";
import DictionaryAbstract from "@/components/dictionary/DictionaryAbstract.vue";
import DevInfoBlock from "@/support/DevInfoBlock.vue";
import InfoBlock from "@/components/infoBlock/InfoBlock.vue";

export default {
    name: 'App',
    components: {
        InfoBlock,
        DevInfoBlock,
        DictionaryAbstract,
        SideMenu
    },
    computed: {
        msgExist() {
            return (this.$store.state.listMsg != null && this.$store.state.listMsg.length > 0)
        }
    }

}
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}

#app > div {
}

.logo {
    width: 200px;
}

body {
    background-color: var(--e-global-color-primary-light);
}

.loading {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>
